// extracted by mini-css-extract-plugin
export default {"userinfowrap":"showuserinfo_userinfowrap__YhhI2","nick":"showuserinfo_nick__dFZKD","is_detail":"showuserinfo_is_detail__+sz4k","is_reply":"showuserinfo_is_reply__S938N"};